import { PasswordlessAuthenticationUpdateType } from '../client-domain.types';

export const passwordlessConfig: PasswordlessAuthenticationUpdateType = {
  enabled: true,
  deliveryMethod: ['EMAIL'],
  magicLinkSettings: {
    android: {
      packageName: 'packageName',
      fingerPrint1: 'fingerPrint1',
      fingerPrint2: 'fingerPrint2',
      fingerPrint3: 'fingerPrint3',
    },
    ios: {
      teamId: 'teamId',
      bundleId: 'bundleId',
    },
  },
};
